import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import moment from "moment";
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import _ from 'lodash';
import numeral from 'numeral';
import {isFloat} from 'validator';

// Components
import DateInput from "../../../components/common/date-input";
import Select from "../../../components/common/virtualized-select";
import SalesOrderLinesTable from "../../../components/common/SalesOrderLinesTable";
import SerieSelector from "../../../components/common/SerieSelector";

// Actions
import {createSalesOrder, cleanSalesOrders} from "../../../actions/sales-orders";
import {getCustomers, cleanCustomers} from "../../../actions/customers";
import {getQuotes, cleanQuotes} from "../../../actions/quotes";
import {getProducts, getProduct, cleanProducts} from "../../../actions/products";
import {getStockList, cleanStockList} from "../../../actions/stock";
import {getSeries, cleanSeries} from "../../../actions/series";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class NewSalesOrder extends Component {
    constructor(props) {
        super(props);
        let quote = -1,
            customer = -1,
            margin = 0,
            lines = List([]),
            salesOrderSubtotal = numeral(0).format(),
            salesOrderVat = numeral(0).format(),
            salesOrderTotal = numeral(0).format()
        ;

        // New SalesOrder from Customers
        if (this.props.location.state && this.props.location.state.customerId) {
            customer = this.props.location.state.customerId;
            if (customer !== -1) {
                this.props.getQuotes({
                    filters: {
                        customer: customer._id,
                        status: 'accepted'
                    },
                    projection: 'quote_code',
                    deleteVirtuals: true
                });
            }
        }

        // New SalesOrder from Quote
        if (this.props.location.state && this.props.location.state.quote) {
            quote = this.props.location.state.quote.get('_id');
            customer = this.props.location.state.quote.getIn(['customer', '_id']);
            margin = this.props.location.state.quote.get('margin');
            if (customer !== -1) {
                this.props.getQuotes({
                    filters: {
                        customer: customer._id,
                        status: 'accepted'
                    },
                    projection: 'quote_code',
                    deleteVirtuals: true
                });
            }
        }

        this.state = {
            canSubmit: false,
            canNewLine: false,
            // series
            serieSelectedId: 'manual',
            serieSelectedValue: '',
            // object fields
            order_code: '',
            document_date: moment(),
            expected_delivery_date: moment(),
            customer,
            quote,
            comments: '',
            margin,
            // costPrices
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            // preview line
            newLinePvp: 0,
            newLineDiscount: 0,
            newLineVat: 0,
            lines,
            // lines
            product: -1,
            warehouse: -1,
            commentsLine: '',
            amount: 0,
            cost_price: 0,
            sale_price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // Statistics
            salesOrderSubtotal,
            salesOrderVat,
            salesOrderTotal,
            // line edit index
            lineToEditIndex: -1
        };
    }
    componentDidMount() {
        this.props.getSeries({ document_type: 'sales_order' });
        this.props.getCustomers({
            filters: {
                status: 'active'
            },
            projection: 'customer_code basic_info.name',
            deleteVirtuals: true
        });
        this.props.getProducts({
            filters: {
                status: 'active'
            },
            projection: 'product_code name',
            deleteVirtuals: true
        });
    }
    componentDidUpdate(prevProps, prevState) {
        // Calculate Statistics
        if (this.state.lines !== prevState.lines) {
            let salesOrderSubtotal = 0, salesOrderVat = 0, salesOrderTotal = 0;

            this.state.lines.forEach(line => {
                let subtotalCost, discount, subtotal, vat;

                subtotalCost = line.get('amount') * line.get('sale_price');
                discount = subtotalCost * (_.round(line.get('discount'), 2) / 100);
                subtotal = subtotalCost - discount;
                vat = subtotal * (_.round(line.get('vat'), 2) / 100);

                salesOrderSubtotal = salesOrderSubtotal + subtotal;
                salesOrderVat = salesOrderVat + vat;
                salesOrderTotal = salesOrderTotal + line.get('total');
            });

            this.setState({
                salesOrderSubtotal: numeral(salesOrderSubtotal).format(),
                salesOrderVat: numeral(salesOrderVat).format(),
                salesOrderTotal: numeral(salesOrderTotal).format()
            });
        }

        // Selected Serie
        if (this.props.series.size > 0 && this.props.series !== prevProps.series) {
            let serieSelectedId = 'manual', serieSelectedValue = '';

            this.props.series.forEach(serie => {
                if (serie.get('is_default')) {
                    serieSelectedId = serie.get('_id');
                    serieSelectedValue = serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                }
            });
            this.setState({ serieSelectedId, serieSelectedValue }, this.validateSalesOrder)
        }

        // Handle products and costPrices
        let products = this.props.products;
        if (products !== prevProps.products) {
            if (products instanceof List) {
                if (products.size > 0) {
                    products = products.map(product => {
                        return product.set('select', `[${product.get('product_code')}] ${product.get('name')}`);
                    });
                }
                products = products.insert(0, Map({ _id: -1, select: 'Selecciona un producto' }));
                this.setState({ products });
            }
            else {
                if (products.get('cost_prices')) {
                    this.setState({
                        costPrices: products.get('cost_prices').insert(0, Map({ _id: -1, price: "Selecciona un precio" }))
                    });
                }
            }
        }
    }
    componentWillUnmount() {
        this.props.cleanSalesOrders();
        this.props.cleanProducts();
        this.props.cleanStockList();
        this.props.cleanQuotes();
        this.props.cleanCustomers();
        this.props.cleanSeries();
    }

    getLineToEdit = index => {
        const line = this.state.lines.get(index);
        const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

        window.scrollTo(0, 0);

        this.props.getProduct(line.getIn(['product', '_id']), {
            projection: '_id',
            populateRefs: true
        });
        this.props.getStockList({
            filters: {
                product: line.getIn(['product', '_id'])
            },
            projection: '-_id warehouse real_amount',
            populateRefs: true
        });

        this.setState({
            product: line.getIn(['product', '_id']),
            selectedCostPrice: -1,
            warehouse: line.getIn(['warehouse', '_id']),
            commentsLine: line.get('comments'),
            amount: line.get('amount'),
            cost_price: line.get('cost_price'),
            sale_price: calcLine.salePrice,
            discount: line.get('discount'),
            vat: line.get('vat'),
            newLinePvp: _.round(calcLine.subtotalCost, 2),
            newLineDiscount: _.round(calcLine.discountLine, 2),
            newLineVat: _.round(calcLine.vatLine, 2),
            total: calcLine.total,
            lineToEditIndex: index
        }, this.validateLine);
    };
    deleteLine = index => {
        this.setState({
            lines: this.state.lines.delete(index)
        });
    };
    onChangeSerieSelected = (serieSelectedId, serieSelectedValue) => {
        this.setState({
            serieSelectedId,
            serieSelectedValue,
            order_code: ''
        }, this.validateSalesOrder);
    };
    validateLine = () => {
        if (this.state.amount !== 0 && this.state.warehouse !== -1) {
            this.setState({ canNewLine: true }, this.validateSalesOrder);
        } else {
            this.setState({ canNewLine: false }, this.validateSalesOrder);
        }
    };
    validateSalesOrder = () => {
        if (
            (this.state.serieSelectedId !== 'manual' || this.state.order_code !== '') &&
            this.state.document_date.isValid() &&
            this.state.customer !== -1 &&
            this.state.margin !== ''
        ) {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }
    };
    handleCreateClick = () => {
        let lines = new List([]);

        this.state.lines.forEach(line => {
            lines = lines.insert(lines.size, line
                .set('product', line.getIn(['product', '_id']))
                .set('warehouse', line.getIn(['warehouse', '_id']))
                .delete('sale_price')
                .delete('total')
            );
        });

        this.props.createSalesOrder({
            serieSelectedId: this.state.serieSelectedId,
            order_code: this.state.order_code,
            document_date: this.state.document_date,
            expected_delivery_date: this.state.expected_delivery_date,
            customer: this.state.customer,
            ...this.state.quote !== -1 ? { quote: this.state.quote } : {},
            comments: this.state.comments,
            margin: this.state.margin,
            lines,
        }, {
            projection: 'order_code document_date expected_delivery_date customer statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'customer',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'sales-orders',
            deleteVirtuals: true
        });
        this.props.history.push('/ventas/pedidos');
    };
    calculateLine = (amount, costPrice, margin, discount, vat) => {
        let salePrice, subtotalCost, discountLine, subtotal, vatLine, total;
        salePrice = _.round(_.round(costPrice, 5) / (1 - (_.round(margin, 2) / 100)), 2);
        subtotalCost = _.round(amount, 5) * salePrice;
        discountLine = subtotalCost * (_.round(discount, 2) / 100);
        subtotal = subtotalCost - discountLine;
        vatLine = subtotal * (_.round(vat, 2) / 100);
        total = _.round(subtotal + vatLine, 2);

        return {
            salePrice,
            subtotalCost,
            discountLine,
            subtotal,
            vatLine,
            total
        }
    };

    render() {

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/pedidos">Pedidos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Pedido</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.push('/ventas/pedidos') }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ this.handleCreateClick }
                                disabled={!this.state.canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de pedido de ventas *</label>
                                                <div className="row">
                                                    <div className="col" style={{ paddingRight: 0 }} >
                                                        { this.state.serieSelectedId === 'manual'
                                                            ? <input
                                                                className="form-control"
                                                                type="text"
                                                                value={this.state.order_code}
                                                                onChange={ (event) => {
                                                                    this.setState({
                                                                        order_code: event.target.value
                                                                    }, this.validateSalesOrder);
                                                                }}
                                                            />
                                                            : <input
                                                                className="form-control"
                                                                type="text"
                                                                value={ this.state.serieSelectedValue }
                                                                disabled={true}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                        { this.props.series.size > 0
                                                            ? <SerieSelector
                                                                series={this.props.series}
                                                                serieSelectedId={this.state.serieSelectedId}
                                                                onChangeSerieSelected={this.onChangeSerieSelected}
                                                            />
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha pedido *</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            document_date: selectedDate
                                                        }, this.validateSalesOrder);
                                                    }}
                                                    value={this.state.document_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha prevista de entrega</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            expected_delivery_date: selectedDate
                                                        });
                                                    }}
                                                    value={this.state.expected_delivery_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-6">
                                            <label>Cliente *</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.customers.toJS()}
                                                value={this.state.customer}
                                                labelKey="select"
                                                valueKey="_id"
                                                matchProp="select"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                onChange={(customer) => {
                                                    if (customer && customer._id !== this.state.customer) {
                                                        if (customer._id !== -1) {
                                                            this.props.getQuotes({
                                                                filters: {
                                                                    customer: customer._id,
                                                                    status: 'accepted'
                                                                },
                                                                projection: 'quote_code',
                                                                deleteVirtuals: true
                                                            });
                                                        }
                                                        this.setState({
                                                            customer: customer._id,
                                                            quote: -1
                                                        }, this.validateSalesOrder);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Presupuesto relacionado</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.quotes.toJS()}
                                                value={this.state.quote}
                                                labelKey="quote_code"
                                                valueKey="_id"
                                                matchProp="quote_code"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                disabled={this.state.customer === -1 || this.props.quotes.size <= 1}
                                                onChange={(quote) => {
                                                    if (quote && quote._id !== this.state.quote) {
                                                        this.setState({
                                                            quote: quote._id
                                                        }, this.validateSalesOrder);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-9">
                                            <label>Comentarios</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.comments}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        comments: event.target.value
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <label>Margen (%) *</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.margin}
                                                onChange={ (event) => {
                                                    let margin = event.target.value;
                                                    let lines = List([]);
                                                    let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                    if (margin === '') margin = '0';
                                                    if (margin >= 100) margin = '99';
                                                    if (isFloat(margin)) {
                                                        // actual lines
                                                        this.state.lines.forEach(line => {
                                                            const sale_price = _.round(_.round(line.get('cost_price'), 5) / (1 - (_.round(margin, 2) / 100)), 2);
                                                            const subtotalCost = line.get('amount') * sale_price;
                                                            const discount = subtotalCost * (_.round(line.get('discount'), 2) / 100);
                                                            const subtotal = subtotalCost - discount;
                                                            const vat = subtotal * (_.round(line.get('vat'), 2) / 100);
                                                            const total = _.round(subtotal + vat, 2);
                                                            lines = lines.push(Map({
                                                                _id: line.get('_id'),
                                                                product: line.get('product'),
                                                                comments: line.get('comments'),
                                                                amount: line.get('amount'),
                                                                cost_price: line.get('cost_price'),
                                                                sale_price,
                                                                discount: line.get('discount'),
                                                                vat: line.get('vat'),
                                                                total
                                                            }));
                                                        });
                                                        // new line
                                                        sale_price = _.round(_.round(this.state.cost_price, 5) / (1 - (_.round(margin, 2) / 100)), 2);
                                                        subtotalCost = _.round(this.state.amount, 5) * sale_price;
                                                        discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                        subtotal = subtotalCost - discount;
                                                        vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                        total = _.round(subtotal + vat, 2);
                                                        this.setState({
                                                            margin: _.round(margin, 2),
                                                            sale_price,
                                                            newLinePvp: _.round(subtotalCost, 2),
                                                            newLineDiscount: _.round(discount, 2),
                                                            newLineVat: _.round(vat, 2),
                                                            total,
                                                            lines
                                                        }, this.validateSalesOrder);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <h4>Lineas de pedido { this.state.lineToEditIndex !== -1 ? <span style={{
                                        paddingLeft: '50px',
                                        color: '#1AB394',
                                        fontStyle: 'italic',
                                        fontWeight: 'bold'
                                    }}>- Modo edición de línea -</span> : '' }</h4>
                                    <div style={{
                                        transition: 'all 0.4s',
                                        margin: '0 -10px',
                                        padding: '10px 10px 0',
                                        ...this.state.lineToEditIndex !== -1 ? { boxShadow: '0 0 10px 1px #1AB394' } : {}
                                    }}>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col-3">
                                                <label>Producto *</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.state.products.toJS()}
                                                    value={this.state.product}
                                                    labelKey="select"
                                                    valueKey="_id"
                                                    matchProp="select"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    onChange={(product) => {
                                                        if (product && product._id !== this.state.product) {
                                                            if (product._id !== -1) {
                                                                this.props.getProduct(product._id, {
                                                                    projection: '_id',
                                                                    populateRefs: true
                                                                });
                                                                this.props.getStockList({
                                                                    filters: {
                                                                        product: product._id
                                                                    },
                                                                    projection: '-_id warehouse real_amount',
                                                                    populateRefs: true
                                                                });
                                                            }
                                                            this.setState({
                                                                product: product._id,
                                                                selectedCostPrice: -1,
                                                                warehouse: -1
                                                            }, this.validateLine);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-3">
                                                <label>Últimos costes del producto</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.state.costPrices.toJS()}
                                                    value={this.state.selectedCostPrice}
                                                    labelKey="price"
                                                    valueKey="_id"
                                                    matchProp="price"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    disabled={this.state.product === -1 || this.state.costPrices.size <= 1}
                                                    onChange={(selectedCostPrice) => {
                                                        if (selectedCostPrice) {
                                                            if (selectedCostPrice._id !== -1) {
                                                                let cost_price = selectedCostPrice.price;
                                                                let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                                if (cost_price === '') cost_price = '0';
                                                                if (isFloat(cost_price.toString())) {
                                                                    sale_price = _.round(_.round(cost_price, 5) / (1 - (_.round(this.state.margin, 2) / 100)), 2);
                                                                    subtotalCost = _.round(this.state.amount, 5) * sale_price;
                                                                    discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                                    subtotal = subtotalCost - discount;
                                                                    vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                                    total = _.round(subtotal + vat, 2);

                                                                    this.setState({
                                                                        selectedCostPrice: selectedCostPrice._id,
                                                                        cost_price,
                                                                        sale_price,
                                                                        newLinePvp: _.round(subtotalCost, 2),
                                                                        newLineDiscount: _.round(discount, 2),
                                                                        newLineVat: _.round(vat, 2),
                                                                        total
                                                                    }, this.validateLine);
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ selectedCostPrice: selectedCostPrice._id });
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-3">
                                                <label>Almacén *</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.props.warehouses.toJS()}
                                                    value={this.state.warehouse}
                                                    labelKey="select"
                                                    valueKey="_id"
                                                    matchProp="select"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    disabled={this.state.product === -1 || this.props.warehouses.size <= 1}
                                                    onChange={(warehouse) => {
                                                        if (warehouse && warehouse._id !== this.state.warehouse) {
                                                            this.setState({
                                                                warehouse: warehouse._id
                                                            }, this.validateLine);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col-12">
                                                <label>Comentarios</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.commentsLine}
                                                    onChange={ (event) => {

                                                        this.setState({
                                                            commentsLine: event.target.value
                                                        });
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col">
                                                <label>Cantidad *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.amount}
                                                    onChange={ (event) => {
                                                        let amount = event.target.value;
                                                        let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                        if (amount === '') amount = '0';
                                                        if (isFloat(amount)) {
                                                            sale_price = _.round(_.round(this.state.cost_price, 5) / (1 - (_.round(this.state.margin, 2) / 100)), 2);
                                                            subtotalCost = _.round(amount, 5) * sale_price;
                                                            discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                            subtotal = subtotalCost - discount;
                                                            vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                amount,
                                                                sale_price,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discount, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            }, this.validateLine);
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Precio coste ud *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.cost_price}
                                                    onChange={ (event) => {
                                                        let cost_price = event.target.value;
                                                        let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                        if (cost_price === '') cost_price = '0';
                                                        if (isFloat(cost_price)) {
                                                            sale_price = _.round(_.round(cost_price, 5) / (1 - (_.round(this.state.margin, 2) / 100)), 2);
                                                            subtotalCost = _.round(this.state.amount, 5) * sale_price;
                                                            discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                            subtotal = subtotalCost - discount;
                                                            vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                cost_price,
                                                                sale_price,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discount, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>PVP ud</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.sale_price}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Descuento (%)</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.discount}
                                                    onChange={ (event) => {
                                                        let discount = event.target.value;
                                                        let subtotalCost, discountLine, subtotal, vat, total;

                                                        if (discount === '') discount = '0';
                                                        if (isFloat(discount)) {
                                                            subtotalCost = _.round(this.state.amount, 5) * this.state.sale_price;
                                                            discountLine = subtotalCost * (_.round(discount, 2) / 100);
                                                            subtotal = subtotalCost - discountLine;
                                                            vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                discount,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discountLine, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>IVA (%) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.vat}
                                                    onChange={ (event) => {
                                                        let vat = event.target.value;
                                                        let subtotalCost, discount, subtotal, total;

                                                        if (vat === '') vat = '0';
                                                        if (isFloat(vat)) {
                                                            subtotalCost = _.round(this.state.amount, 5) * this.state.sale_price;
                                                            discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                            subtotal = subtotalCost - discount;
                                                            vat = subtotal * (_.round(vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                vat: event.target.value,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discount, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>PVP (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLinePvp}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Descuento (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLineDiscount}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>IVA (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLineVat}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Total (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.total}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col-auto" style={{ paddingTop: 23 }} >
                                                { this.state.lineToEditIndex !== -1
                                                    ? <button
                                                        className="btn btn-primary"
                                                        disabled={!this.state.canNewLine}
                                                        onClick={() => {
                                                            let lines = new List(this.state.lines);
                                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                                            const product = this.state.products.get(index);
                                                            index = this.props.warehouses.findIndex( warehouse => warehouse.get('_id') === this.state.warehouse );
                                                            const warehouse = this.props.warehouses.get(index);

                                                            lines = lines.set(this.state.lineToEditIndex, Map({
                                                                product,
                                                                warehouse,
                                                                comments: this.state.commentsLine,
                                                                amount: _.round(this.state.amount, 5),
                                                                cost_price: _.round(this.state.cost_price, 5),
                                                                sale_price: this.state.sale_price,
                                                                discount: _.round(this.state.discount, 2),
                                                                vat: _.round(this.state.vat, 5),
                                                                total: _.round(this.state.total, 2)
                                                            }));

                                                            this.setState({
                                                                lines,
                                                                product: -1,
                                                                selectedCostPrice: -1,
                                                                warehouse: -1,
                                                                commentsLine: '',
                                                                amount: 0,
                                                                cost_price: 0,
                                                                sale_price: 0,
                                                                vat: 0,
                                                                newLinePvp: 0,
                                                                newLineDiscount: 0,
                                                                newLineVat: 0,
                                                                discount: 0,
                                                                total: 0,
                                                                canNewLine: false,
                                                                lineToEditIndex: -1
                                                            }, this.validateSalesOrder);
                                                        }}
                                                    >
                                                        <Icon
                                                            style={{ margin: '2px 0px' }}
                                                            icon="tick" title="guardar"
                                                        />
                                                    </button>
                                                    : <button
                                                        className="btn btn-custom"
                                                        disabled={!this.state.canNewLine}
                                                        onClick={() => {
                                                            let lines = new List(this.state.lines);
                                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                                            const product = this.state.products.get(index);
                                                            index = this.props.warehouses.findIndex( warehouse => warehouse.get('_id') === this.state.warehouse );
                                                            const warehouse = this.props.warehouses.get(index);

                                                            lines = lines.insert(lines.size, Map({
                                                                product,
                                                                warehouse,
                                                                comments: this.state.commentsLine,
                                                                amount: _.round(this.state.amount, 5),
                                                                cost_price: _.round(this.state.cost_price, 5),
                                                                sale_price: this.state.sale_price,
                                                                discount: _.round(this.state.discount, 2),
                                                                vat: _.round(this.state.vat, 5),
                                                                total: _.round(this.state.total, 2)
                                                            }));

                                                            this.setState({
                                                                lines,
                                                                product: -1,
                                                                selectedCostPrice: -1,
                                                                warehouse: -1,
                                                                commentsLine: '',
                                                                amount: 0,
                                                                cost_price: 0,
                                                                sale_price: 0,
                                                                vat: 0,
                                                                newLinePvp: 0,
                                                                newLineDiscount: 0,
                                                                newLineVat: 0,
                                                                discount: 0,
                                                                total: 0,
                                                                canNewLine: false
                                                            }, this.validateSalesOrder);
                                                        }}
                                                    >
                                                        <Icon
                                                            style={{ margin: '2px 0px' }}
                                                            icon="plus" title="Añadir"
                                                        />
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <SalesOrderLinesTable
                                        editMode={true}
                                        salesOrderLines={this.state.lines}
                                        deleteLine={this.deleteLine}
                                        getLineToEdit={this.getLineToEdit}
                                        editLineIndex={this.state.lineToEditIndex}
                                    />
                                    <div className="row stats-zone d-flex justify-content-end">
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.salesOrderSubtotal }</span>
                                            <span>Subtotal</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.salesOrderVat }</span>
                                            <span>IVA</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.salesOrderTotal }</span>
                                            <span>Total</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const customersReducer = state.customers;
    const quotesReducer = state.quotes;
    const productsReducer = state.products;
    const stockReducer = state.stock;
    const seriesReducer = state.series;

    // Customers
    let customers = customersReducer.get('payload') || List([]);
    if (!(customers instanceof List)) customers = List([]);
    if (customers.size > 0) {
        customers = customers.map(customer => {
            return customer.set('select', `[${customer.get('customer_code')}] ${customer.getIn(['basic_info', 'name'])}`);
        });
    }
    customers = customers.insert(0, Map({ _id: -1, select: 'Selecciona un cliente' }));

    // Quotes
    let quotes = quotesReducer.get('payload') || List([]);
    if (!(quotes instanceof List)) quotes = List([]);
    quotes = quotes.insert(0, Map({ _id: -1, quote_code: 'Selecciona un presupuesto' }));

    // Products
    const products = productsReducer.get('payload') || List([]);

    // Warehouses / Product StockList
    let warehouses = stockReducer.get('payload') || List([]);
    if (!(warehouses instanceof List)) warehouses = List([]);
    if (warehouses.size > 0) {
        warehouses = warehouses.map(warehouse => {
            return warehouse
                .set('select', `[${warehouse.getIn(['warehouse', 'warehouse_code'])}] ${warehouse.getIn(['warehouse', 'name'])} (${warehouse.get('real_amount')} uds)`)
                .set('_id', warehouse.getIn(['warehouse', '_id']))
                .set('name', warehouse.getIn(['warehouse', 'name']));
        });
    }
    warehouses = warehouses.insert(0, Map({ _id: -1, select: 'Selecciona un almacén' }));

    // Series
    let series = seriesReducer.get('payload') || List([]);

    return {
        customers,
        quotes,
        products,
        warehouses,
        series
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: (query) => dispatch(getCustomers(query)),
        getQuotes: (query) => dispatch(getQuotes(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        getStockList: (query) => dispatch(getStockList(query)),
        getSeries: (query) => dispatch(getSeries(query)),
        createSalesOrder: (salesOrder, options) => dispatch(createSalesOrder(salesOrder, options)),
        cleanSalesOrders: () => dispatch(cleanSalesOrders()),
        cleanCustomers: () => dispatch(cleanCustomers()),
        cleanQuotes: () => dispatch(cleanQuotes()),
        cleanProducts: () => dispatch(cleanProducts()),
        cleanStockList: () => dispatch(cleanStockList()),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewSalesOrder);



// WEBPACK FOOTER //
// ./src/containers/sales/orders/NewSalesOrder.js